import { BASE_URL, ENV_URL } from "./Config";

export const LOGIN_PAGE = ENV_URL.concat("skiply-portal/Login");

export const API_URL = {
  LOGIN: BASE_URL.concat("skiply-auth/portalloginuser"),

  DOWNLOAD_UPDATE_TEMPLATE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/download/template"
  ),
  DOWNLOAD_DELETE_TEMPLATE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/deletelist/download/template"
  ),
  DOWNLOAD_USER_TEMPLATE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/download/bulknotificationtemplate"
  ),
  DOWNLOAD_FAILURE_RECORD_EXCEL_FILE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/fileactivitystatus/download"
  ),
  DOWNLOAD_DELIVERY_STATUS_EXCEL_FILE: BASE_URL.concat(
    "skiply-merchantdata/push/deliveryStatus/download"
  ),

  UPLOAD_TRACKER: BASE_URL.concat(
    "skiply-merchantdata/studentdata/getprocessedFilesCollection"
  ),

  UPLOAD_STUDENT_TEMPLATE: BASE_URL.concat(
    "skiply-merchantdata/notificationconstructs/uploadStudentData"
  ),
  UPLOAD_UPDATE_TEMPLATE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/upload"
  ),
  UPLOAD_DELETE_TEMPLATE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/deletelist/upload"
  ),

  VALIDATE_UPDATE_FILE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/process"
  ),
  VALIDATE_DELETE_FILE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/deletelist/process"
  ),

  GET_PROCESS_STATUS: BASE_URL.concat(
    "skiply-merchantdata/studentdata/getProcessStatus"
  ),
  GET_DELETE_PROCESS_STATUS: BASE_URL.concat(
    "skiply-merchantdata/studentdata/deletelist/getProcessStatus"
  ),

  GET_LIST_SEC: BASE_URL.concat("skiply-merchantdata/studentdata/getlistsec"),
  DELETE_GET_LIST_SEC: BASE_URL.concat(
    "skiply-merchantdata/studentdata/deletelist/getlistsec"
  ),

  SUBMIT_UPDATE: BASE_URL.concat("skiply-merchantdata/studentdata/existing/"),
  SUBMIT_DELETE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/deletelist/existing/"
  ),

  COMMIT_UPDATE: BASE_URL.concat("skiply-merchantdata/studentdata/commit"),
  COMMIT_DELETE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/deletelist/commit"
  ),

  COMMIT_PROGRESS_PERCENTAGE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/commit/percentage"
  ),

  UPDATE_VALIDATE_PERCENTAGE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/getvalidationpercentage"
  ),
  DELETE_VALIDATE_PERCENTAGE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/deletelist/getvalidationpercentage"
  ),

  RETRY_UPDATE_PROGRESS: BASE_URL.concat(
    "skiply-merchantdata/studentdata/retry"
  ),
  RETRY_DELETE_PROGRESS: BASE_URL.concat(
    "skiply-merchantdata/studentdata/deletelist/retry"
  ),
  ABORT_UPLOADING: BASE_URL.concat(
    "skiply-merchantdata/studentdata/abortuploading"
  ),
  ABORT_UPDATE_PROGRESS: BASE_URL.concat(
    "skiply-merchantdata/studentdata/abort"
  ),
  ABORT_DELETE_PROGRESS: BASE_URL.concat(
    "skiply-merchantdata/studentdata/deletelist/abort"
  ),

  SINGLE_DELETE: BASE_URL.concat("skiply-merchantdata/studentdata/delete"),
  SINGLE_ADD_STUDENT: BASE_URL.concat(
    "skiply-merchantdata/studentdata/addstudent"
  ),

  DOWNLOAD_ERR_FILE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/download"
  ),
  DOWNLOAD_DELETE_ERR_FILE: BASE_URL.concat(
    "skiply-merchantdata/studentdata/deletelist/download"
  ),

  PUBLIC_KEY: BASE_URL.concat("skiply-portaluserprofile/publickey"),
  GET_USERS: BASE_URL.concat("skiply-portaluserprofile/getportaluser/"),
  BROADCAST: BASE_URL.concat("skiply-notification/push/broadcast"),
  VERIFY_OTP: BASE_URL.concat("skiply-auth/portalverifyotpcustom"),
  FORGOT_PASSWORD: BASE_URL.concat(
    "skiply-portaluserprofile/forgotpasswordcustom"
  ),
  UPDATE_PASSWORD: BASE_URL.concat(
    "skiply-portaluserprofile/updatepasswordcustom"
  ),
  DELETE_USER: BASE_URL.concat("skiply-portaluserprofile/portalprofile"),
  UPDATE_SINGLE_STUDENT: BASE_URL.concat(
    "skiply-merchantdata/studentdata/update"
  ),
  ADD_SINGLE_STUDENT: BASE_URL.concat(
    "skiply-merchantdata/studentdata/addstudent"
  ),

  MERCHANT: BASE_URL.concat("skiply-merchantdata/merchant"),
  GET_MERCHANTS_BY_ROLE: BASE_URL.concat("skiply-merchantdata/merchant/list"),
  MERCHANT_TYPES: BASE_URL.concat("skiply-merchantdata/merchantTypes"),
  GET_GRADE_DIVISON: BASE_URL.concat(
    "skiply-merchantdata/merchant/schoolgradedivision"
  ),
  GET_STUDENT_IDS: BASE_URL.concat("skiply-merchantdata/merchant/studentids"),
  GET_STUDENT_IDS_ALL: BASE_URL.concat("skiply-merchantdata/merchant/studentids/all"),
  PUSH_NOTIFICATION: BASE_URL.concat(
    "skiply-merchantdata/notificationconstructs"
  ),
  NOTIFICATION_HISTORY: BASE_URL.concat(
    "skiply-merchantdata/notificationconstructs/fetchConstructs"
  ),
  NOTIFICATION_HISTORY_COUNT: BASE_URL.concat(
    "skiply-merchantdata/notificationconstructs/fetchConstructs/count"
  ),

  GET_STUDENT_LIST: BASE_URL.concat("skiply-merchantdata/studentdata/getlist"),
  GET_STUDENT_COUNT: BASE_URL.concat("skiply-merchantdata/studentdata/counts"),
  GET_STUDENT_RECORDS: BASE_URL.concat(
    "skiply-merchantdata/studentdata/filter"
  ),

  FETCH_MERCHANT_WILDCARD: BASE_URL.concat(
    "skiply-merchantdata/merchant/wildcardsearch/"
  ),
  SYNC_MERCHANT: BASE_URL.concat("skiply-merchantdata/merchant/sync/"),
  GET_MERCHANT_DATA: BASE_URL.concat(
    "skiply-merchantdata/merchant/getmerchantdata/"
  ),
  MIGRATE_DATA: BASE_URL.concat("skiply-merchantdata/merchant/migratedata/"),

  REPORT_TRANSACTION_STANDARD: BASE_URL.concat(
    "skiply-report/reports/standard/merchants/"
  ),
  REPORT_TRANSACTION_CUSTOM: BASE_URL.concat(
    "skiply-report/reports/custom/merchants/"
  ),

  REPORT_GET_ALL_FIELDNAMES: BASE_URL.concat(
    "skiply-report/reports/standard/getAllFieldNames/"
  ),

  REPORT_CUSTOM_SAVE: BASE_URL.concat("skiply-report/templates/savetemplate/"),
  REPORT_CUSTOM_UPDATE: BASE_URL.concat(
    "skiply-report/templates/updatetemplate/"
  ),

  REPORT_CUSTOM_COUNT: BASE_URL.concat("skiply-report/templates/count"),
  REPORT_CUSTOM_ALL: BASE_URL.concat("skiply-report/templates/merchants/"),
  REPORT_CUSTOM_DELETE: BASE_URL.concat(
    "skiply-report/templates/deletetemplate/"
  ),
  DOWNLOAD_REPORT: BASE_URL.concat("skiply-report/reports/download"),
  //for Schedule

  REPORTS_SCHEDULED_CREATE: BASE_URL.concat(
    "skiply-report/reports/scheduledreports/create/"
  ),
  REPORT_SCHEDULED_CUSTOM: BASE_URL.concat(
    "skiply-report/templates/merchants/"
  ),

  //for Schedule History

  REPORT_SCHEDULED_READ: BASE_URL.concat(
    "skiply-report/reports/scheduledreports/query"
  ),
  DELETE_SCHEDULED_HISTORY: BASE_URL.concat(
    "skiply-report/reports/scheduledreports/"
  ),
  REPORT_ADHOC_INSTRUCTION: BASE_URL.concat(
    "skiply-report/reports/adhoc-instructions"
  ),

  //for remove user
  APP_INFO: BASE_URL.concat("skiply-userprofile/app-info"),
  DELETE_USER_PROFILE: BASE_URL.concat("skiply-userprofile/v2/profile"),
  GENERATE_OTP_REQUEST: BASE_URL.concat(
    "skiply-userprofile/profile/generateotp"
  ),
  VERIFY_OTP_REQUEST: BASE_URL.concat("skiply-userprofile/otp/generic/verify"),
  REGENERATE_OTP_REQUEST: BASE_URL.concat(
    "skiply-userprofile/profile/regenerateotp"
  ),
  ONBOARD_MERCHANTS_TO_EPP: BASE_URL.concat(
    "skiply-merchantdata/merchant/epp/onboard"
  ),
  PRODUCTS: BASE_URL.concat("skiply-schprod/cms/product/search"),
  PRODUCT_DETAILS: BASE_URL.concat("skiply-schprod/cms/product/"),
  PRODUCT_CATEGORIES: BASE_URL.concat("skiply-schprod/cms/categories"),
  PRODUCT_CATEGORY: BASE_URL.concat("skiply-schprod/cms/category"),
  UPLOAD_PRODUCT_IMAGE: BASE_URL.concat("skiply-schprod/cms/image/base64"),
  GET_PRODUCT_IMAGE: BASE_URL.concat("skiply-schprod/cms/image/"),
  SAVE_PRODUCT: BASE_URL.concat("skiply-schprod/cms/product"),
  GET_PRODUCT_FORMS: BASE_URL.concat("skiply-schprod/cms/forms"),
  GET_STUDENT_LIST_EXPORT: BASE_URL.concat("skiply-merchantdata/studentdata/export"),

    // Smart Plans
  SMART_PLANS: BASE_URL.concat("skiply-recurring/api/manage-recurring/search"),
  CANCEL_SMART_PLAN: BASE_URL.concat("skiply-recurring/api/manage-recurring/cancel/instruction"),
  EXPORT_SMART_PLANS: BASE_URL.concat("skiply-recurring/api/recurring-reports/summary?merchantId="),
  
  // Manage Checkout (Payment Links)
  MANAGE_CHECKOUT_SEARCH: BASE_URL.concat("skiply-payment/manage-checkout/search"),
  MANAGE_CHECKOUT_CANCEL: BASE_URL.concat("skiply-payment/manage-checkout/cancel"),
  MANAGE_CHECKOUT_DETAILS: BASE_URL.concat("skiply-payment/manage-checkout/"),

     // Direct Debits
  DIRECT_DEBITS: BASE_URL.concat("skiply-recurring/api/manage-recurring/search"),
  CANCEL_DIRECT_DEBIT: BASE_URL.concat("skiply-recurring/api/manage-recurring/cancel/instruction"),

  // Pricing
  PRICING: BASE_URL.concat("skiply-payment/pricing"),
  
  ENROLLMENT_STATUS: BASE_URL.concat("skiply-schprod/enrollment/student/"),
  RE_ENROLLMENT_ACCEPT: BASE_URL.concat("skiply-schprod/enrollment/accept/v2"),
  RE_ENROLLMENT_REJECT: BASE_URL.concat("skiply-schprod/enrollment/reject"),
  CANCEL_ENROLLMENT: BASE_URL.concat("skiply-schprod/enrollment/cancel"),
  SKIPLY_EXTERNAL_PRODUCTS: BASE_URL.concat("skiply-schprod/enrollment/metadata"),
};

//Used in School Configuration page
//Default values
// if we need to show it in any order, add position and stort it accordingly
export const SEARCH_CRITERIA = [
  {
    id: "firstName",
    enabled: false,
    label: "First Name",
  },
  {
    id: "lastName",
    enabled: false,
    label: "Last Name",
  },
  {
    id: "phoneNumber",
    enabled: false,
    label: "Phone Number",
  },
  {
    id: "parentID",
    enabled: false,
    label: "Parent ID",
  },
  {
    id: "studentID",
    enabled: false,
    label: "Student ID",
  },
  {
    id: "emailID1",
    enabled: false,
    label: "Email ID",
  },
];

export const ADMIN_TYPE = {
  SUPERADMIN: "SUPERADMIN",
  SCHOOLADMIN: "SCHOOLADMIN",
  SALESADMIN: "SALESADMIN",
};

export const NOTIFICATION_ENUM = {
  SCHOOL_CUSTOM: "SCHOOL_LEVEL_NOTIFY_CUSTOM",
  SCHOOL_BROADCAST: "SCHOOL_LEVEL_NOTIFY_BROADCAST",
  STUDENT: "STUDENT_LEVEL_NOTIFY",
  BULK: "BULK_STUDENT_LEVEL_NOTIFY",
};

export const GRID_COLUMN_EMPTY_ICONS = {
  menu: " ",
  filter: " ",
};
